<template>
	<div>
		<div class="sf-search-layout__body__container">
			<sf-search-layout>
				<el-row :gutter="20">
					<el-col :span="4">
						<multi-select-combo
							:label="`${getMessage_('QWCC001122')} (${getMessage_('QWCC002020')})`"
							paramKey="lgrpCd"
							:collapseTags="true"
							:options="lgrpList"
							@multiCommChange="setSearchParam"
						></multi-select-combo>
					</el-col>
					<el-col :span="4">
						<multi-select-combo
							:label="`${getMessage_('QWCC001123')} (${getMessage_('QWCC002020')})`"
							paramKey="sgrpCd"
							:collapseTags="true"
							:options="filteredSgrpList"
							@multiCommChange="setSearchParam"
						></multi-select-combo>
					</el-col>
					<el-col :span="4">
						<select-combo
							:label="getMessage_('QWCC001163')"
							paramKey="useYn"
							:options="useYnList"
							:propData="searchParams.useYn"
							@commChange="setSearchParam"
						></select-combo>
					</el-col>
				</el-row>
				<template slot="button">
					<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
						{{ getButtonMsg_(scrId, 'CR') }}
					</sf-button>
				</template>
			</sf-search-layout>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';
import MultiSelectCombo from '@qms/Components/MultiSelectCombo';

export default {
	props: { scrId: { type: String, default: '' } },
	components: { SelectCombo, MultiSelectCombo },
	async created() {
		try {
			await this.searchList();
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message || error });
		}
	},
	data() {
		return {
			filteredSgrpList: []
		};
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
			if (param.key === 'lgrpCd') {
				const filtered = this.sgrpAllList.filter(item => this.searchParams?.lgrpCd?.includes(item.commCdType));
				this.filteredSgrpList = filtered.map(({ label, value }) => {
					return {
						label,
						value
					};
				});
			}
			if (param.key === 'useYn') {
				this.searchList();
			}
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			try {
				if (!this.isPqyUser) throw new Error(this.getMessage_('QWCC001923')); //해당메뉴에 접근 권한이 없습니다. 관리자에게 권한을 요청하세요.
				await this.getList_();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed
	}
};
</script>

<style></style>
